import { createContext } from "react";

const OverlayContext = createContext(null);

export default OverlayContext;

